import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';

const SimpleLogin = () => {
  const [credentials, setCredentials] = useState({
    email: 'admin@cozykeys.com',
    password: 'david4567'
  });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');

    try {
      console.log('🔄 Attempting login...');
      
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/auth/landlord/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(credentials)
      });

      console.log('📡 Response status:', response.status);
      const data = await response.json();
      console.log('📡 Response data:', data);

      if (!response.ok) {
        throw new Error(data.detail || 'Login failed');
      }

      // Store token and user data
      localStorage.setItem('landlord_token', data.access_token);
      localStorage.setItem('landlord_user', JSON.stringify(data.user));

      setMessage(`✅ Login successful! Token stored. Redirecting...`);
      
      // Redirect to dashboard after 2 seconds
      setTimeout(() => {
        window.location.href = '/';
      }, 2000);

    } catch (err) {
      console.error('❌ Login error:', err);
      setMessage(`❌ Error: ${err.message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <Card className="w-full max-w-md">
        <CardHeader>
          <CardTitle>Simple Login Test</CardTitle>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <Label>Email</Label>
              <Input
                type="email"
                value={credentials.email}
                onChange={(e) => setCredentials(prev => ({...prev, email: e.target.value}))}
              />
            </div>
            <div>
              <Label>Password</Label>
              <Input
                type="password"
                value={credentials.password}
                onChange={(e) => setCredentials(prev => ({...prev, password: e.target.value}))}
              />
            </div>
            <Button type="submit" disabled={loading} className="w-full">
              {loading ? 'Logging in...' : 'Login'}
            </Button>
          </form>
          
          {message && (
            <div className="mt-4 p-3 bg-gray-100 rounded">
              {message}
            </div>
          )}
          
          <div className="mt-4 p-3 bg-blue-50 rounded text-sm">
            <p><strong>Test Instructions:</strong></p>
            <p>1. Click Login button</p>
            <p>2. Check browser console (F12)</p>
            <p>3. Should redirect to dashboard if working</p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default SimpleLogin;